import { pedagogico } from "@/constants/pedagogico";
import { secretaria_financeiro } from "@/constants/secretaria_financeiro";

function getServico(setor, servico) {
  const servicos = setor === "pedagogico" ? pedagogico : secretaria_financeiro
  const data = servicos?.find(element => element.id === servico);
  return data?.label || "Não identificado"
}

export default getServico;
